var exports = {
  "wave": "wave__eAtr5x",
  "pulse": "pulse__iSNQQB",
  "skeleton": "skeleton__c5fLaY",
  "rounded": "rounded__er6wPa",
  "pill": "pill__VJOX6F",
  "elliptical": "elliptical__52GWVt",
  "rectangular": "rectangular__E8KpBt",
  "text": "text__AoCFqt",
  "widthXl": "widthXl__KdG9Ts",
  "widthLg": "widthLg__L357av",
  "widthMd": "widthMd__N_PddV",
  "widthSm": "widthSm__TaLrJs",
  "heightXl": "heightXl__Q-BbSF",
  "heightLg": "heightLg__Ewc1uv",
  "heightMd": "heightMd__7mVR7U",
  "heightSm": "heightSm__S99g6S",
};

__webpack_require__.r(module.exports = exports);
